// 测试打印用
import { getLodop } from '../../LodopFuncs'
let LODOP;
let printText;
let dayinData={};
export default function startPrint(index,hide) {
    var itemStr = ``;

    // console.log(index);
    LODOP = getLodop();// 获取LODOP对象的主过程
    index.itemInfo.forEach(element => {
        itemStr += `
                    <div style="display:flex">
                        <div style="flex:0 0 55%;margin-bottom:5px;word-break:break-all;">${element.title}[${element.specification}]</div>
                        <div align="center" style="flex:0 0 15%;">*${element.amount}</div>
                        <div align="right" style="flex:0 0 30%;">${element.totalPrice}</div>
                    </div>`
    });

    if(hide==true){
        printText = `
        <p style="font-size:45px;font-weight:bold;text-align:center">#${index.id.substring(index.id.length - 4)}</p>
        <p style="margin-top:15px;margin-bottom:0;font-size:20px;font-weight:bold">姓名: ${index.addressName.replace(/(?<=.)./g, '*')}</p>
        <p style="margin-bottom:0;font-size:20px;font-weight:bold">手机: ${index.addressMobile.substr(0, 3)}****${index.addressMobile.substr(7)}</p>
        <p style="margin:0;margin-bottom:5px;font-size:20px;font-weight:bold">地址: ${index.addressDetail}</p>
        <p style="margin:0;margin-bottom:5px;font-size:20px;font-weight:bold">备注: ${index.note}</p>
        <p>下单时间：${index.createdTime}</p>
        <div style="width:225px;height:0px;border-top:1px black dashed;" />
        <div>${itemStr}</div>
        <div style="width:225px;height:0px;border-top:1px black dashed;" />
        <p style="text-align:right">总价: ${index.totalPrice}${(index.discountAmount && index.discountAmount > 0) ? `(已优惠${index.discountAmount}元)` : ''}</p>
        
        <p style="text-align:center;font-size:15px;margin-top:10px">****紫东线上生活超市****</p>`;
    }
    else{
        printText = `
        <p style="font-size:45px;font-weight:bold;text-align:center">#${index.id.substring(index.id.length - 4)}</p>
        <p style="margin-top:15px;margin-bottom:0;font-size:20px;font-weight:bold">姓名: ${index.addressName}</p>
        <p style="margin-bottom:0;font-size:20px;font-weight:bold">手机: ${index.addressMobile}</p>
        <p style="margin:0;margin-bottom:5px;font-size:20px;font-weight:bold">地址: ${index.addressDetail}</p>
        <p style="margin:0;margin-bottom:5px;font-size:20px;font-weight:bold">备注: ${index.note}</p>
        <p>下单时间：${index.createdTime}</p>
        <div style="width:225px;height:0px;border-top:1px black dashed;" />
        <div>${itemStr}</div>
        <div style="width:225px;height:0px;border-top:1px black dashed;" />
        <p style="text-align:right">总价: ${index.totalPrice}${(index.discountAmount && index.discountAmount > 0) ? `(已优惠${index.discountAmount}元)` : ''}</p>
        
        <p style="text-align:center;font-size:15px;margin-top:10px">****紫东线上生活超市****</p>`;
    }

    

    if (LODOP != false) {
        const data = [{}];
        dayin(data, printText);
    }
}

function setDayinData(temp) {
    // 整理打印数据
    dayinData.enterAmount = temp.enterAmount
    dayinData.versionNo = temp.versionNo
    dayinData.productBatchNo = temp.productBatchNo
    dayinData.remarks = temp.remarks
    dayinData.productId = temp.productId
    dayinData.productLineId = temp.productLineId
    dayinData.shiftsType = temp.shiftsType
    dayinData.productSpecId = temp.productSpecId
    dayinData.sheetId = temp.sheetId

    const strTaskName = 'XX单' + temp.productBatchNo
    return strTaskName
}

function dayin(data, printText) {
    LODOP = getLodop()// 获取LODOP对象的主过程
    const strTaskName = setDayinData(data)

    LODOP.PRINT_INIT(strTaskName)
    LODOP.SET_PRINTER_INDEX(-1)// -1特指操作系统内设定的默认打印机

    LODOP.SET_PRINT_PAGESIZE(3,'58mm',0)
    LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')// 设置以纸张边缘为基点
    // LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Full-Width')
    
    var strStyle = '<style>p{margin:0;}</style>';

    LODOP.ADD_PRINT_BARCODE('5mm','1mm','60mm','10mm',"128Auto","1672739746999901503")

    LODOP.ADD_PRINT_HTM('20mm', '0mm', '100%', '100%', strStyle + printText)

    
    LODOP.PRINT()// 直接打印
    // LODOP.PREVIEW()// 打印预览
}



